var _a;
import { DcfSdkEnumsObj } from "../../enums/DcfSdkEnum";
export var NETWORK_CONSUMER_VALIDATION_PROFILES = (_a = {},
    _a[DcfSdkEnumsObj.MASTERCARD] = {
        firstNameLength: { min: 1, max: 50 },
        lastNameLength: { min: 1, max: 50 },
    },
    _a[DcfSdkEnumsObj.VISA] = {
        firstNameLength: { min: 1, max: 30 },
        lastNameLength: { min: 2, max: 80 },
    },
    _a);
export var getConsumerValidationProfile = function (cardBrand) {
    return NETWORK_CONSUMER_VALIDATION_PROFILES[cardBrand];
};
var networkFirstNameLengths = Object.values(NETWORK_CONSUMER_VALIDATION_PROFILES).map(function (profile) { return profile.firstNameLength; });
var networkLastNameLengths = Object.values(NETWORK_CONSUMER_VALIDATION_PROFILES).map(function (profile) { return profile.lastNameLength; });
export var getCommonLength = function (ranges) {
    var commonRange = {
        min: Math.max.apply(Math, ranges.map(function (range) { return range.min; })),
        max: Math.min.apply(Math, ranges.map(function (range) { return range.max; })),
    };
    if (!ranges.length || commonRange.min > commonRange.max) {
        throw new Error("Consumer validation profiles do not overlap.");
    }
    return commonRange;
};
// Network length limits are applied conservatively as JavaScript UTF-16 code units.
export var getConsumerNameLength = function (value) { return value.length; };
var getSupportedPrefillLength = function (ranges) { return ({
    min: Math.min.apply(Math, ranges.map(function (range) { return range.min; })),
    max: Math.max.apply(Math, ranges.map(function (range) { return range.max; })),
}); };
export var CONSUMER_FIRST_NAME_LENGTH = getCommonLength(networkFirstNameLengths);
export var CONSUMER_LAST_NAME_LENGTH = getCommonLength(networkLastNameLengths);
export var CONSUMER_FIRST_NAME_PREFILL_LENGTH = getSupportedPrefillLength(networkFirstNameLengths);
export var CONSUMER_LAST_NAME_PREFILL_LENGTH = getSupportedPrefillLength(networkLastNameLengths);
